import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSettlupIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.27961 10.9245C9.36272 10.9245 11.0514 9.25677 11.0514 7.19954C11.0514 5.14232 9.36272 3.47461 7.27961 3.47461C5.19651 3.47461 3.50781 5.14232 3.50781 7.19954C3.50781 9.25677 5.19651 10.9245 7.27961 10.9245Z",
			stroke: "currentColor",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.5 7.20009C0.5 3.49914 3.53688 0.5 7.28438 0.5C9.67744 0.5 12.0644 1.8856 13.2427 3.997",
			stroke: "currentColor",
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.0996 3.45074L13.2558 3.99658L13.8085 1.86719",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.8931 7.19922C13.8931 10.9002 10.8562 13.8993 7.10874 13.8993C4.71568 13.8993 2.3287 12.5137 1.15039 10.4023",
			stroke: "currentColor",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.36136 10.6183L1.14444 10.4023L0.925781 12.5857",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.04102 7.23552L7.28614 8.22524L9.00501 6.17383",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgSettlupIcon;
